var map = {
	"./GRANDE_headerbanner.png": "b5f9",
	"./MINI_headerbanner.png": "6b6e",
	"./headerbanner-grande.jpg": "8320",
	"./headerbanner-mini.jpg": "7fde"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f0d0";